var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex sp-wrapper justify-content-center align-items-center vh-100"},[_c('span',{staticClass:"spinner-border spinner-icon",attrs:{"role":"status","aria-hidden":"true"}})])
}]

export { render, staticRenderFns }